<template>
  <details-header>
    <template v-slot:avatar>
      <v-img class="mx-auto" width="200" :src="$images.LOGO" />
    </template>
    <template v-slot:headerAppend>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="my-auto">
        <template v-if="survey.finishDate">
          <v-icon color="primary" class="mr-2">query_builder</v-icon>
          <span class="secondarytext--text">
            Complete by {{ survey.finishDate | longDate }}
          </span>
        </template>
      </v-col>
    </template>
    <v-row class="pa-4" v-if="!showBenchmarkMessage">
      <v-col cols="12">
        <v-card class="pa-4">
          <v-card-title>
            {{ survey.title }}
            <v-icon color="darkaccent" class="ml-2">assignment</v-icon>
          </v-card-title>
          <v-card-text>
            {{ survey.description }}
          </v-card-text>
          <v-card-text class="font-italic pt-0">
            For employees of {{ profile.companyName }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-btn color="secondary" @click="nextStep">
          Get Started <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="pa-4" v-else>
      <v-col cols="12">
        <v-card class="pa-4">
          <v-card-title>
            Culture Baseline Enabled
            <v-icon color="success" class="ml-2">flash_on</v-icon>
          </v-card-title>
          <v-card-text>
            {{ survey.benchmarkMessage }}
          </v-card-text>
          <v-card-text class="pt-0 pl-0">
            <v-btn color="info" text @click="nextStep">
              I understand
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </details-header>
</template>

<script>
import { mapGetters } from "vuex";
import DetailsHeader from "@/components/common/DetailsHeader";
export default {
  name: "SurveyIntro",
  components: { DetailsHeader },
  data: () => ({ showBenchmarkMessage: false }),
  computed: {
    ...mapGetters({
      profile: "profile/profile",
      survey: "survey/survey"
    })
  },
  methods: {
    nextStep() {
      if (this.survey.benchmarkMessage && !this.showBenchmarkMessage) {
        this.showBenchmarkMessage = true;
      } else {
        this.$store.dispatch("survey/nextStep");
      }
    }
  }
};
</script>
